export const parseSidesToValue = (sidesList, values) => {
  if (
    sidesList &&
    sidesList &&
    sidesList instanceof Array &&
    values instanceof Array &&
    sidesList.length === values.length
  ) {
    const result = [];
    values.forEach((val, indx) => {
      if (val && sidesList[indx]) result.push(sidesList[indx].value);
    });
    return result;
  }
  return null;
};

export const translatedExaminationList = (examinationList, i18n) => {
  try {
    if (examinationList && i18n) {
      const currentLang = i18n.language;
      const result = examinationList.map(item => ({
        value: item.value,
        title: item.localization.find(
          loc => loc.lang === currentLang || loc.lang === 'en'
        ).title
      }));
      return result;
    }
    return [];
  } catch (e) {
    return [];
  }
};

export const checkSidesGroupeError = form =>
  form &&
  form.fields &&
  form.fields.sides &&
  form.syncErrors &&
  form.syncErrors.sides &&
  String(form.syncErrors.sides._error);

export const validate = values => {
  const errors = {};
  // examinations
  if (
    !values.examinations ||
    (values.examinations instanceof Array && values.examinations.length < 1)
  ) {
    errors.examinations = 'required';
  }

  // sides
  if (values.sides && values.sides instanceof Array) {
    if (values.sides.every(_el => _el === false)) {
      errors.sides = values.sides.map(() => 'required');
      errors.sides._error = 'modal_to_radiology_side_error_groupe';
    }
  }

  return errors;
};
